<div class="show-modal" [style]="isOpenModal ? 'top: 0' : 'top: 100vh'">
  <div class="show-modal--content">
    <ng-template #modalRender></ng-template>
  </div>
  <div class="backdrop" (click)="destroy()"></div>
</div>
